import type { ModelMapWidgetConfiguration } from "@/lib/api";
import { ModelMapBaseLayerStyle } from "@/lib/mapbox/base-layer-styles";
import { initialViewportPresets } from "@/features/widget-forms/shared/initial-viewport-presets";

/**
 * Fill a partial live draft with the defaults the model-map renderer needs so an
 * in-progress configuration still previews (empty layer/series/overlay arrays,
 * default base layer + viewport, model_map discriminant). Mirrors the obs-map
 * preview seeding and the form's own normalization.
 */
export function toPreviewConfiguration(
  draft: Partial<ModelMapWidgetConfiguration>,
): ModelMapWidgetConfiguration {
  return {
    ...draft,
    type: "model_map",
    model_id: draft.model_id ?? "",
    parameter_map_layer_configurations: draft.parameter_map_layer_configurations ?? [],
    parameter_time_series_configurations: draft.parameter_time_series_configurations ?? [],
    static_map_overlay_configurations: draft.static_map_overlay_configurations ?? [],
    base_layer_style: draft.base_layer_style || ModelMapBaseLayerStyle.Monochrome,
    initial_viewport_bounds: draft.initial_viewport_bounds ?? initialViewportPresets.nl,
  } as ModelMapWidgetConfiguration;
}
